import { useQuery } from 'react-query'

import { Tax } from '@webapp/platform/finance/entities/Tax'
import { taxQueryConfig } from '@webapp/platform/finance/query-configs/tax'

type UseQueryTaxReturn = {
  tax: Nullable<Tax>
  isFetching: boolean
}

export const useQueryTax = (id: number): UseQueryTaxReturn => {
  const { data, isFetching } = useQuery({
    ...taxQueryConfig.getTax(id),
  })

  return {
    tax: data?.data ? new Tax(data.data) : null,
    isFetching,
  }
}
